module.exports = __webpack_public_path__ + "static/media/submarine.43c0f8ae.png";